/**
 * Created by fers on 05.02.16.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router/lib/Link';
import urlMapping from '../app/URLMapping';
import {getLocale} from '../locales';
import {Grid} from './Grid.react';

import * as Tool from './Tool';
import {injectIntl, IntlShape} from 'react-intl';

interface TableDetailProps {
    children?: React.ReactNode;
    childrenBefore?: boolean;
    columns: any;
    data?: object;
    fixedTitleWidth?: boolean;
    hideEmpty?: boolean;
    intl?: object;
    isPreview?: boolean;
    metadata: object;
    name?: object;
    noTitles?: boolean;
    render?: (...args: unknown[]) => unknown;
}

class TableDetail extends React.Component<TableDetailProps> {
    static propTypes = {
        children: PropTypes.node,
		childrenBefore: PropTypes.bool,
        columns: PropTypes.any.isRequired,
        data: PropTypes.object,
        fixedTitleWidth: PropTypes.bool,
        hideEmpty: PropTypes.bool,
        intl: PropTypes.object,
		isPreview: PropTypes.bool,
        metadata: PropTypes.object.isRequired,
		name: PropTypes.object,
        noTitles: PropTypes.bool,
        render: PropTypes.func,
    };

    static defaultProps = {
        noTitles: false,
        hideEmpty: true,
        fixedTitleWidth: true,
    };

    render() {
        const { columns, metadata } = this.props;
        let fields = metadata.fields();
		let columnMap = Grid.getColumnsForMap(columns, fields);

        return (
            <table className="table-detail">
                {this.props.fixedTitleWidth ?
                    <colgroup>
                        <col style={{"width":"150px"}}/>
                    </colgroup>
                : null}
                <tbody>
					{this.props.childrenBefore ? this.props.children : null}

                    {columnMap.map(columnMap => {
						let column = columnMap.id;
						let columnMapping = columnMap.map;
						let columnMetadata = columnMap.metadata;

                        if (!columnMapping) {
                            return (<tr key={column}><td style={{color: 'red'}}>Missing item {column}!</td></tr>);
                        }
                        let type = columnMapping.type;
                        let parent = columnMetadata.length >= 2 ? columnMetadata[columnMetadata.length - 2] : columnMetadata[columnMetadata.length - 1];
						let value = Tool.getDataForColumn(column, fields, this.props.data);

                        if ('render' in columnMap.object) {
							value = columnMap.object.render(column, value, null, columnMapping.type);
                        } else {
                            value = Tool.tranformDataForView(metadata.entity(), columnMapping, this.props.intl.formatMessage, Tool.getDataForColumn(column, fields, this.props.data));
                        }
						if (this.props.isPreview && this.props.columns[column] && this.props.columns[column].fieldDef) {
                            value = this.props.columns[column].fieldDef.exampleData;
						}

                        /* we fetch all mappings and test if all are visible */
                        let isVisible = true;

                        for (let m of columnMetadata) {
                            if (m.visibility) {
                                isVisible = isVisible && m.visibility(this.props.data);

                                if (!isVisible) {
                                    break;
                                }
                            }
                        }

                        if (this.props.render) {
                            value = this.props.render(value, column, this.props.data, null, type);
                        }

						let columnName;
						if (this.props.name && this.props.name[getLocale()]) {
							columnName = this.props.name[getLocale()];
						}
						else if (columnMap && columnMap.object && columnMap.object.name && columnMap.object.name[getLocale()]) {
							columnName = columnMap.object.name[getLocale()];
						}
						else if (parent.name) {
							columnName = this.props.intl.formatMessage({id: "metadata." + metadata.entity() + "." + parent.key, defaultMessage: parent.name });
						}
						else if (column === "dativery") {
                            columnName = "";
                        } else {
                            columnName = this.props.intl.formatMessage({
                                defaultMessage: type.name,
                                id: "metadata." + (parent.type && typeof parent.type === 'object' ? parent.type.to().entity() : metadata.entity()) + "." + type.key
                            });
						}

						if ('linkToView' in columnMap.object && columnMap.object.linkToView === true) {
							let linkObject = null;

							for (let i = columnMetadata.length - 1; i >= 0; i--) {
								if ('to' in columnMetadata[i]) {
									linkObject = columnMetadata[i];
									break;
								}
                            }
                            if (linkObject) {
                                let linkObjectData = Tool.getDataForColumn(linkObject.key, fields, this.props.data);
                                columnName = linkObject.name;
                                if (linkObjectData) {
                                    value = <Link to={urlMapping.getUrl(linkObject.to(), 'view', linkObjectData)}>{value}</Link>;
                                }
                            }
                        }

                        let hasValue = value ? true : false;
                        if (Array.isArray(value) && value.length === 0) {
                            hasValue = false;
                        }

                        if (hasValue && this.props.hideEmpty) {
                            return (<tr key={column} style={isVisible ? {} : {display: "none"}}>
                                {this.props.noTitles ? null : <td>{columnName}{columnName ? ":" : ""}</td>}
                                <td>{value}</td>
                            </tr>);
                        }
                    })}

					{!this.props.childrenBefore ? this.props.children : null}
                </tbody>
            </table>
        );
    }
}

export default injectIntl(TableDetail);
